import * as Constants from "../constants";

/**
 * API client for the tenant's CUSTOM company profile fields.
 *
 *   GET    /profilefield                  -> list this tenant's custom fields
 *   POST   /profilefield                  -> create/update fields (upsert by profile_field_id);
 *                                            accepts an ARRAY so several fields save in one call
 *   DELETE /profilefield/{profileFieldId} -> delete a single custom field
 *
 * System fields are NOT served here — they are code-owned (see systemProfileFields.ts)
 * and merged in on the client.
 */

const url = () => `${Constants.baseURL}${Constants.profilefieldAPI}`;
const headers = () => Object.assign({}, Constants.commonHeaders);

/* fetch() doesn't reject on HTTP errors and DELETE may return an empty body. */
async function parse(response) {
  const text = await response.text();
  const body = text ? JSON.parse(text) : {};
  if (!response.ok) {
    const message =
      (body && (body.userMessage || body.message)) ||
      `Request failed (${response.status})`;
    throw new Error(message);
  }
  return body;
}

export async function getProfileFieldsApi() {
  const response = await fetch(url(), {
    method: "GET",
    headers: headers(),
    crossDomain: true,
  });
  return parse(response);
}

/** Create/update fields. `payload` is an array of field objects (upsert by profile_field_id). */
export async function saveProfileFieldsApi(payload) {
  const response = await fetch(url(), {
    method: "POST",
    headers: headers(),
    crossDomain: true,
    body: JSON.stringify(payload),
  });
  return parse(response);
}

export async function deleteProfileFieldApi(profileFieldId) {
  const response = await fetch(`${url()}/${profileFieldId}`, {
    method: "DELETE",
    headers: headers(),
    crossDomain: true,
  });
  return parse(response);
}
